export default class DiasSemanaEnum {
    static Domingo = 0
    static Segunda= 1
    static Terca = 2
    static Quarta = 3
    static Quinta = 4
    static Sexta = 5
    static Sabado = 6
}
